import React, { useEffect, useState, useRef } from 'react';
import { UsersIcon, PercentIcon, StarIcon, FileTextIcon, SearchIcon } from 'lucide-react';
const PlayerHeader = () => {
  const [isFavorite, setIsFavorite] = useState(false);
  const [showListPopover, setShowListPopover] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLists, setSelectedLists] = useState<string[]>([]);
  const popoverRef = useRef<HTMLDivElement>(null);
  const allLists = [{
    id: '1',
    name: 'Top Prospects 2024'
  }, {
    id: '2',
    name: 'Free Agents Watch'
  }, {
    id: '3',
    name: 'Trade Targets'
  }, {
    id: '4',
    name: 'Injury Recovery'
  }, {
    id: '5',
    name: 'Draft Board'
  }, {
    id: '6',
    name: 'Veteran Leaders'
  }, {
    id: '7',
    name: 'Defensive Specialists'
  }, {
    id: '8',
    name: 'Clutch Performers'
  }];
  const visibleLists = allLists.slice(0, 5);
  const searchableLists = allLists.filter(l => !visibleLists.find(v => v.id === l.id)).filter(l => l.name.toLowerCase().includes(searchQuery.toLowerCase()));
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target as Node)) {
        setShowListPopover(false);
        if (selectedLists.length === 0) setIsFavorite(false);
      }
    };
    if (showListPopover) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showListPopover, selectedLists]);
  const handleStarClick = () => {
    if (isFavorite) {
      setIsFavorite(false);
      setSelectedLists([]);
      setShowListPopover(false);
    } else {
      setIsFavorite(true);
      setShowListPopover(true);
    }
  };
  const toggleList = (id: string) => {
    setSelectedLists(prev => prev.includes(id) ? prev.filter(l => l !== id) : [...prev, id]);
  };
  return <div className="flex justify-between items-center" data-id="element-252">
      <h1 className="text-3xl font-bold" data-id="element-253">NAME SURNAME</h1>
      <div className="flex items-center space-x-3" data-id="element-254">
        <div className="flex space-x-1" data-id="element-255">
          <div className="relative" ref={popoverRef} data-id="element-256">
            <button onClick={handleStarClick} className={`p-2 rounded-full transition-colors ${isFavorite ? 'text-yellow-500 bg-yellow-50' : 'text-gray-400 hover:bg-gray-200'}`} data-id="element-257">
              <StarIcon className="w-5 h-5" fill={isFavorite ? 'currentColor' : 'none'} data-id="element-258" />
            </button>

            {/* List Popover */}
            {showListPopover && <div className="absolute right-0 top-full mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden" data-id="element-259">
                <div className="px-3 py-2 border-b bg-gray-50" data-id="element-260">
                  <p className="text-xs font-bold text-gray-600 uppercase tracking-wide" data-id="element-261">
                    Add to list
                  </p>
                </div>
                <div className="max-h-52 overflow-y-auto" data-id="element-262">
                  {visibleLists.map(list => {
                const isSelected = selectedLists.includes(list.id);
                return <button key={list.id} onClick={() => toggleList(list.id)} className="w-full flex items-center gap-2.5 px-3 py-2 hover:bg-gray-50 transition-colors text-left" data-id="element-263">
                        <StarIcon className={`w-4 h-4 flex-shrink-0 ${isSelected ? 'text-yellow-500' : 'text-gray-300'}`} fill={isSelected ? 'currentColor' : 'none'} data-id="element-264" />
                        <span className={`text-sm ${isSelected ? 'font-semibold text-gray-900' : 'text-gray-600'}`} data-id="element-265">
                          {list.name}
                        </span>
                      </button>;
              })}
                  {searchQuery && searchableLists.map(list => {
                const isSelected = selectedLists.includes(list.id);
                return <button key={list.id} onClick={() => toggleList(list.id)} className="w-full flex items-center gap-2.5 px-3 py-2 hover:bg-gray-50 transition-colors text-left" data-id="element-266">
                          <StarIcon className={`w-4 h-4 flex-shrink-0 ${isSelected ? 'text-yellow-500' : 'text-gray-300'}`} fill={isSelected ? 'currentColor' : 'none'} data-id="element-267" />
                          <span className={`text-sm ${isSelected ? 'font-semibold text-gray-900' : 'text-gray-600'}`} data-id="element-268">
                            {list.name}
                          </span>
                        </button>;
              })}
                </div>
                <div className="border-t px-3 py-2" data-id="element-269">
                  <div className="relative" data-id="element-270">
                    <SearchIcon className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-271" />
                    <input type="text" placeholder="Search lists" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-8 pr-3 py-1.5 text-sm border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500" data-id="element-272" />
                  </div>
                </div>
              </div>}
          </div>
          <button className="p-2 rounded-full text-gray-400 hover:bg-gray-200" data-id="element-273">
            <FileTextIcon className="w-5 h-5" data-id="element-274" />
          </button>
        </div>
        <button className="p-2 rounded-full bg-gray-200 hover:bg-gray-300" data-id="element-275">
          <UsersIcon className="w-5 h-5" data-id="element-276" />
        </button>
        <button className="p-2 rounded-full bg-gray-200 hover:bg-gray-300" data-id="element-277">
          <PercentIcon className="w-5 h-5" data-id="element-278" />
        </button>
      </div>
    </div>;
};
export default PlayerHeader;